import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import {
    PreloadAllModules,
    provideRouter,
    withInMemoryScrolling,
    withPreloading
} from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { environment } from '../environments/environment';

import { routes } from './app.routes';
import { provideCms } from './cms';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(
            routes,
            withInMemoryScrolling({
                anchorScrolling: 'enabled',
                scrollPositionRestoration: 'enabled'
            }),
            withPreloading(PreloadAllModules)
        ),
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.useServiceWorker,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
        provideCms(environment.cmsUrl),
        { provide: LOCALE_ID, useValue: 'de-CH' }
    ]
};
